import React, { useCallback, useState } from 'react';

export default function FileUploader({ onFileSelect, acceptedFormats = ['application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'], maxSize = 5 * 1024 * 1024 }) {
	const [dragOver, setDragOver] = useState(false);
	const [file, setFile] = useState(null);
	const [error, setError] = useState('');

	const validate = useCallback(
		(f) => {
			if (!f) return false;
			if (!acceptedFormats.includes(f.type)) {
				setError('Only PDF and DOCX files are allowed');
				return false;
			}
			if (f.size > maxSize) {
				setError('File exceeds 5MB limit');
				return false;
			}
			setError('');
			return true;
		},
		[acceptedFormats, maxSize]
	);

	function handleFiles(files) {
		const f = files?.[0];
		if (validate(f)) {
			setFile(f);
			onFileSelect?.(f);
		}
	}

	return (
		<div>
			<div
				className={`border-2 border-dashed rounded-md p-6 text-center ${dragOver ? 'border-primary-600 bg-primary-50' : 'border-gray-300'}`}
				onDragOver={(e) => {
					e.preventDefault();
					setDragOver(true);
				}}
				onDragLeave={() => setDragOver(false)}
				onDrop={(e) => {
					e.preventDefault();
					setDragOver(false);
					handleFiles(e.dataTransfer.files);
				}}
			>
				<p className="text-sm text-gray-600">Drag and drop your resume here, or click to browse</p>
				<input
					type="file"
					accept=".pdf,.docx,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
					className="hidden"
					id="resume-upload-input"
					onChange={(e) => handleFiles(e.target.files)}
				/>
				<label htmlFor="resume-upload-input" className="mt-2 inline-block text-primary-600 underline cursor-pointer">
					Browse files
				</label>
				{file && <p className="mt-2 text-sm">Selected: {file.name}</p>}
				{error && <p className="mt-2 text-xs text-red-600">{error}</p>}
			</div>
		</div>
	);
}


